import { Injectable } from "@angular/core";
import {AndroidVersion} from "@shared/interfaces/android.interface";
import '@shared/interfaces/global.interface';


@Injectable({
    providedIn: 'root'
})
export class AndroidService {

    private _version: AndroidVersion = {
        appVersion: "unknown",
        buildNumber: 0,
        androidVersion: "0",
        sdkInt: 0,
        manufacturer: "unknown",
        model: "unknown",
        brand: "unknown",
        device: "unknown",
        hardware: "unknown"
    }
    ;

    constructor(
        // private _http: HttpClient,
        // private _toasterService: ToasterService,
    ) { }

    public isAndroid(): boolean {
        return ((typeof Bridge !== 'undefined') && (!!Bridge.interfaces?.Android));
    }

    public async getVersion(): Promise<void> {
        try {
            if (typeof Bridge === 'undefined') {
                //console.warn("Bridge is not defined. Are you sure you're running in an Android WebView environment?");
                return;
            }
            let res = await Bridge.interfaces.Android.getVersion();
            this._version = res.data;
        } catch (e){
                console.error("Error getting Android version:", e);
        }
    }
    get version(): AndroidVersion {
        return this._version;
    }
}
